module.exports = __webpack_public_path__ + "img/sprite.077a1e4d.svg";